import { Helmet } from "react-helmet-async";
import { lazy, Suspense } from "react";
import { LuxuryHeader } from "@/components/LuxuryHeader";
import { LuxuryFooter } from "@/components/LuxuryFooter";
import { LuxuryHero } from "@/components/sections/LuxuryHero";
import { KeyBenefits } from "@/components/sections/KeyBenefits";
import { ProductsEarly } from "@/components/sections/ProductsEarly";
import { BeforeAfter } from "@/components/sections/BeforeAfter";
import { useIntersectionLoader } from "@/hooks/useIntersectionLoader";

// Lazy load below-fold sections
const FAQSection = lazy(() => import("@/components/sections/FAQSection").then(m => ({ default: m.FAQSection })));

// Minimal section placeholder to prevent layout shift
const SectionPlaceholder = () => (
  <div className="py-16 md:py-20 bg-background min-h-[400px]" />
);

const HomePage = () => {
  const { ref: lazyRef, isVisible } = useIntersectionLoader('400px');

  return (
    <>
      <Helmet>
        <title>Christmas Tree Food - The Best Shot At A Fresher, Greener Tree All Season</title>
        <meta name="description" content="Pre-converted nutrients that help your Christmas tree stay fresh. Helps keep needles on, water clean, and your home smelling like Christmas morning. Made in USA. Free shipping." />
        <link rel="canonical" href="https://christmastreefood.com" />
        <meta property="og:title" content="Christmas Tree Food - The Best Shot At A Fresher Tree All Season" />
        <meta property="og:description" content="Pre-converted nutrients that help your Christmas tree stay fresh. Helps keep needles on, water clean, and your home smelling like Christmas morning." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://christmastreefood.com" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Christmas Tree Food - The Best Shot At A Fresher Tree All Season" />
        <meta name="twitter:description" content="Pre-converted nutrients that help your Christmas tree stay fresh. Helps keep needles on, water clean, and your home smelling like Christmas morning." />
      </Helmet>
      <div className="min-h-screen bg-background">
        <LuxuryHeader />
        <main>
          <LuxuryHero />
          <KeyBenefits />
          <BeforeAfter />
          {/* Lazy load trigger point */}
          <div ref={lazyRef} />
          <ProductsEarly />
          {isVisible ? (
            <Suspense fallback={<SectionPlaceholder />}>
              <FAQSection />
            </Suspense>
          ) : (
            <SectionPlaceholder />
          )}
        </main>
        <LuxuryFooter />
      </div>
    </>
  );
};

export default HomePage;
